import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { MemorandumDatetimePickerComponent } from '../memorandum-datetime-picker/memorandum-datetime-picker.component';

@Component({
  selector: 'app-memorandum-revisi',
  templateUrl: './memorandum-revisi.component.html',
  styleUrls: ['./memorandum-revisi.component.scss'],
})
export class MemorandumRevisiComponent {
  load = false;
  id = '';
  keterangan = '';
  dateValue2 = '';
  expdate = '';

  constructor(
    public modalController: ModalController,
    public util: UtilService,
    public navParams: NavParams,
    public api: ApiService
  ) {
    this.id = this.navParams.data.id;
  }

  async openDatePicker() {
    const modal = await this.modalController.create({
      component: MemorandumDatetimePickerComponent,
      cssClass: ['wd-req2', 'datetime-picker-dim'],
      componentProps: {
        value: this.toDatetimeLocal(this.dateValue2 || this.expdate),
      },
    });

    if (typeof document !== 'undefined') {
      document.body.classList.add('datetime-picker-open');
    }

    try {
      await modal.present();
      const result: any = await modal.onDidDismiss();

      if (result?.role === 'confirm' && result?.data?.value) {
        const selected = result.data.value;
        this.dateValue2 = selected;
        this.expdate = selected.replace('T', ' ').slice(0, 16);
      }
    } finally {
      if (typeof document !== 'undefined') {
        document.body.classList.remove('datetime-picker-open');
      }
    }
  }

  submit() {
    if (!String(this.keterangan || '').trim()) {
      this.util.showToast('Keterangan wajib diisi', 'danger', 'bottom');
      return;
    }

    const body = {
      keterangan: this.keterangan.trim(),
      reschedule_dtm: this.expdate
        ? `${this.expdate.replace('T', ' ')}:00`
        : null,
    };

    this.load = true;
    this.api
      .post('backoffice/credit-analyst/app-memo/reject/' + this.id, body)
      .subscribe(
        (data: any) => {
          this.load = false;
          if (data.error == 0) {
            this.util.showToast(data.message, 'success', 'bottom');
            this.api.dismissData('', 'confirm');
          } else {
            this.util.showToast(data.message, 'danger', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          this.api.errorCond(error);
        }
      );
  }

  dismiss() {
    this.api.dismiss();
  }

  private toDatetimeLocal(value: string): string {
    if (!value) {
      return '';
    }
    return value.includes('T') ? value.slice(0, 16) : value.replace(' ', 'T').slice(0, 16);
  }
}
